import type { Phase, WorkItem } from '../domain/workflow'

type PhaseColumns = Record<string, WorkItem[]>

const groupWorkItemsByStep = (phase: Phase, workItems: WorkItem[]): PhaseColumns => {
	const columns: PhaseColumns = {}

	for (const step of phase.teamWorkflow.steps) {
		columns[step.id] = []
	}

	for (const item of workItems) {
		// Concluded items are not live cards: completed ones surface in the
		// phase Done column, cancelled/archived ones in the Archived section.
		if (item.status === 'completed' || item.status === 'cancelled' || item.status === 'archived') continue
		if (item.currentPhaseId === phase.id && item.currentStepId in columns) {
			columns[item.currentStepId]!.push(item)
		}
	}

	return columns
}

export type { PhaseColumns }
export { groupWorkItemsByStep }
